import { GenesysCloudUser } from './models/user.model';
import { EntityState } from '@ngrx/entity';
import { userEntityAdapter } from 'common/store/genesys-cloud/users/adapters/user.adapter';

export interface GenesysCloudUsersState {
  user?: GenesysCloudUser;
  users?: EntityState<GenesysCloudUser>;
}

export const initialState = (): GenesysCloudUsersState => ({
  users: userEntityAdapter.getInitialState()
});

